import type { McpServer } from '@modelcontextprotocol/sdk/server/mcp.js';
import { approveCollectionTriageClipApi } from '@repo/sdk';
import { z } from 'zod';

export function registerApproveTriageClip(server: McpServer): void {
  server.registerTool(
    'approve_triage_clip',
    {
      title: 'Approve a triage clip (admin)',
      description:
        'Approve a clip in a collection triage queue. Requires an admin session. verticalRejected marks the clip as failing vertical-format checks.',
      inputSchema: {
        collectionId: z.number().int().positive(),
        clipId: z.number().int().positive(),
        verticalRejected: z.boolean().optional(),
      },
    },
    async ({ collectionId, clipId, verticalRejected }) => {
      const { data } = await approveCollectionTriageClipApi({
        collectionId,
        clipId,
        verticalRejected,
      });
      return {
        content: [{ type: 'text', text: JSON.stringify(data?.data ?? null) }],
      };
    },
  );
}
